import { render, staticRenderFns } from "./EmbedBlock.vue?vue&type=template&id=3bba6f20&"
import script from "./EmbedBlock.vue?vue&type=script&lang=js&"
export * from "./EmbedBlock.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports